export default "__VITE_ASSET__CU8aNRhQ__"